import React from 'react';
import { Helmet } from 'react-helmet-async';

import { PortalProfile } from 'playup-web-core';

import useNotify from '../../../hooks/useNotify';
import GreenIdModal from './GreenIdModal';
import PortalSessionContext from '../../../contexts/PortalSessionContext/PortalSessionContext';
import { SocketContext } from '../../../contexts/SocketContext';
import UpdatePasswordModal from './UpdatePasswordModal';
import ProfileForm from './ProfileForm';
import AvatarUpdateButton from './AvatarUpdateButton';
import useOpenModal from '../../../hooks/useOpenModal';
import appConfig from '../../../appConfig';

const Profile: React.FC = () => {
	const { refreshPortalUser, user } = React.useContext(PortalSessionContext);
	const { bindAuthChannelEvent } = React.useContext(SocketContext);
	const isUS = appConfig.regions.isUS;
	const notify = useNotify();
	const handleOpenModal = useOpenModal();

	React.useEffect(refreshPortalUser, [refreshPortalUser]);

	// socket lister for user verification status updated
	React.useEffect(() => {
		if (!user?.id) return;

		const unbindUpdates = bindAuthChannelEvent(`private-user.${user.id}`, 'updated', refreshPortalUser);
		return unbindUpdates;
	}, [bindAuthChannelEvent, refreshPortalUser, user?.id]);

	if (!user) return null;

	return (
		<>
			<Helmet title="Profile" />
			<PortalProfile
				isUS={isUS}
				user={user}
				refreshPortalUser={refreshPortalUser}
				notify={notify}
				handleDeposit={() => handleOpenModal('deposit')}
				GreenId={GreenIdModal}
				ResetPasswordModal={UpdatePasswordModal}
				ProfileForm={ProfileForm}
				AvatarUploader={AvatarUpdateButton}
			/>
		</>
	);
};

export default Profile;
